import React from "react"
import { SelectInput } from "react-admin"
import { PoiPublishState } from "src/models/Poi"

const PoiPublishStateInput = () => {
  return <SelectInput source="publish_state" label={"Publish state"} optionText="name" name={"publish_state"} choices={Object.keys(PoiPublishState).map((key) => ({ id: key, name: key }))} />
}

export default PoiPublishStateInput
